import { CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import axios from "axios";
import * as React from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Layout } from "../components/layout";

interface ResponseDataType {
  database: string;
  environment: string;
  group: string;
  id: number;
  language: string;
  name: string;
  note: string;
  sales: string;
}

interface ResponseColumnType {
  title: string;
  field: string;
}

interface ResponseType {
  columns: ResponseColumnType[];
  data: ResponseDataType[];
}

interface TableData {
  group: string;
  items: ResponseDataType[];
}

const url = "https://script.google.com/macros/s/AKfycbyfkRNM0A_TZj-VDYO8kGM4M0SUEFiUbmX9-S7Rvqia7HeNoiOZMq3mXeT2L1sC4byxxg/exec";
const tableRatio = ["15%", "40%", "15%", "15%", "15%"];

const Tables: React.FC<{ columns: ResponseColumnType[], data: ResponseDataType[] }> = ({ columns, data }) => {
  const target = [] as string[];
  return (
    <TableContainer className="mb-5 rounded animation-slide-in">
      <Table size="small" aria-label="test table">
        <TableHead className="bg-dark">
          <TableRow>
            {columns.map((i, index) => {
              target.push(i.field);
              return (<TableCell className="text-light" key={index} style={{ width: tableRatio[index] }}>{i.title}</TableCell>);
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((i: { [key: string]: any }, dataKey) =>
            <TableRow key={dataKey}>
              {target.map((j, targetKey) => <TableCell key={targetKey}>{i[j]}</TableCell>)}
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const WorksPage: React.FC = () => {
  const { t } = useTranslation("translations", { keyPrefix: "WORKS" });
  const [data, setData] = React.useState<{ columns: ResponseColumnType[], tables: TableData[] }>({ columns: [], tables: [] });

  React.useEffect(() => {
    (async () => {
      try {
        const res = await axios.get<ResponseType>(url, {});
        const tables = [] as TableData[];
        res.data.data.forEach(i => {
          const dataIndex = tables.findIndex(j => j.group === i.group);
          if (dataIndex === -1) {
            tables.push({ group: i.group, items: [i] });
          } else {
            tables[dataIndex].items.push(i);
          }
        });
        setData({ columns: res.data.columns, tables });
      } catch (error) {
        console.error("Error fetching works data:", error);
      }
    })();
  }, []);

  return (
    <Layout title="WORKS" subtitle={t("SUBTITLE")}>
      <div className="my-4 text-center">
        <h3>{t("LIST.TITLE")}</h3>
        <Container className="mt-4 mb-5">
          <p>{t("LIST.DESC_1")}</p>
          <p>{t("LIST.DESC_2")}</p>
          <p>{t("LIST.DESC_3")}</p>
        </Container>
        <div className="mx-4">
          {!data.tables.length &&
            <>
              <div className="mx-auto my-5" style={{ maxWidth: "30rem" }}><CircularProgress sx={{ color: "#AAB" }} size={40} /></div>
              <p><small>{t("LIST.LOADING")}</small></p>
            </>
          }

          {Boolean(data.tables.length) && data.tables.map((item, key) => <Tables key={key} columns={data.columns} data={item.items} />)}
        </div>
      </div>
    </Layout>
  );
};
